// extracted by mini-css-extract-plugin
module.exports = {"links":"sCnCM","name":"GfBNZ","errorIcon":"_535w9","accountType":"vWaKO","na":"_5tiaJ"};